import React, {useState} from 'react';
import {Button, ButtonGroup, Toolbar, Typography} from '@material-ui/core';
import {lighten, withStyles} from '@material-ui/core/styles'
import clsx from 'clsx';
import {DeleteIcon, EditIcon, MoveIcon} from '../../../../helpers/Icons'
import FoldersBulkEditDialog from './FoldersBulkEditDialog';
import MoveFolderItemsDialog from './MoveFolderItemsDialog';
import DeleteFoldersDialog from "./DeleteFoldersDialog";
import DataPaginationSmall from "../../../util/data-table/DataPaginationSmall";

const styles = (theme) => ({
  root: {
    padding: '0.25em 0.5em',
    gap: '0.5em',
    minHeight: 'auto',
    border: '1px solid #ddd',
    borderBottom: 'none',
    position:'sticky',
    left: 0,
    display:'flex',
    flexWrap:'wrap',
    backgroundColor: '#fcfcfc',
  },
  highlight: theme.palette.type === 'light' ? {
    color: theme.palette.secondary.main,
    backgroundColor: lighten(theme.palette.secondary.light, 0.85),
  } : {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.secondary.dark,
  },
  title: {
    marginRight: '0.75em',
    fontSize: '0.7225em',
    fontWeight: 500,
    whiteSpace:'nowrap',
    textTransform: 'uppercase',
  },
  toolbar: {
    flexWrap:'wrap',
    margin: '1px 0 0 1px',
    '& > button':{
      margin: '-1px 0 0 -1px',
      borderColor: '#c4c4c4 !important',
      width:'5rem',
      boxSizing: 'border-box',
    }
  },
  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225em',
    backgroundColor: '#ffffffdd',
    height: '34px',
    '& span:first-child > span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
});

function SelectedFoldersToolbar(props) {
  const {pageItemCount, selectedItems, folderList, addFolder, handleMoveSelected,
    handleDeleteSelectedAndDeleteItems, handleDeleteSelectedAndMoveItems, handleSaveFolders,
    controller, itemCount, handlePageChange, handleChangeRowsPerPage, mindfileUserLevel, classes } = props;

  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [moveOpen, setMoveOpen] = useState(false);
  const selectedCount = Object.keys(selectedItems || {}).length;

  return (
    <>
      <Toolbar id="selectedToolbar" className={clsx(classes.root, {[classes.highlight]: selectedCount > 0,})} >
        { mindfileUserLevel <= 2 ?
              <>
            <Typography className={classes.title} color="inherit" variant="subtitle1" component="div">
              <span id="selectedCount">{selectedCount}</span> selected
            </Typography>
            <ButtonGroup className={classes.toolbar}>
              <Button
                id="editSelected"
                startIcon={<EditIcon />}
                className={classes.toolbarButton}
                onClick={() => setEditOpen(true)}
                disabled={selectedCount === 0}
                variant="outlined"
              >
                Edit
              </Button>
              <Button
                id="moveSelected"
                startIcon={<MoveIcon />}
                className={classes.toolbarButton}
                onClick={() => setMoveOpen(true)}
                disabled={selectedCount === 0}
                variant="outlined"
              >
                Move
              </Button>
              { mindfileUserLevel <= 1 ?
                <Button
                  id="deleteSelected"
                  startIcon={<DeleteIcon />}
                  className={classes.toolbarButton}
                  onClick={() => setDeleteOpen(true)}
                  disabled={selectedCount === 0}
                  variant="outlined"
                >
                  Delete
                </Button>
                : null
              }
            </ButtonGroup>
          </>
          : null
        }
        <DataPaginationSmall
          controller={controller}
          itemsTotal={itemCount}
          pageItemCount={pageItemCount}
          handlePageChange={handlePageChange}
          handleChangeRowsPerPage={handleChangeRowsPerPage} />
      </Toolbar>

      {mindfileUserLevel > 2 ? null : <>
      {editOpen ?
        <FoldersBulkEditDialog
          id="editSelectedDialog"
          open={editOpen}
          handleClose={setEditOpen.bind(this, false)}
          foldersMap={selectedItems}
          handleSaveFolders={handleSaveFolders}
        />
        : null
      }
      {moveOpen ?
        <MoveFolderItemsDialog
          id="moveSelectedDialog"
          open={moveOpen}
          handleClose={setMoveOpen.bind(this, false)}
          foldersMap={selectedItems}
          folderList={folderList}
          addFolder={addFolder}
          handleMoveSelected={handleMoveSelected}
        />
        : null
      }
      {mindfileUserLevel > 1 ? null : deleteOpen ?
        <DeleteFoldersDialog
          id="deleteSelectedDialog"
          open={deleteOpen}
          handleClose={setDeleteOpen.bind(this, false)}
          foldersMap={selectedItems}
          folderList={folderList}
          addFolder={addFolder}
          handleDeleteSelectedAndDeleteItems={handleDeleteSelectedAndDeleteItems}
          handleDeleteSelectedAndMoveItems={handleDeleteSelectedAndMoveItems}
        />
        : null
      }
      </>
      }
    </>
  );
}

export default withStyles(styles)(SelectedFoldersToolbar);
